import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * API handler to update an order using centralized API utility.
 *
 * @param {String} id - Order ID to be updated
 * @param {Object} order - Updated order details
 * @returns {Promise<Object>} - Response with updated order details
 * @throws Will throw an error if the request fails
 * 
 * Mishra
 */
const updateOrder = async (id, order) => {
  return await apiCall(`${AUTH_ROUTES.ORDER_API_ENDPOINT}/${id}`, {
    method: "PUT",
    body: order,
  });
};

export default updateOrder;
